import React, { Component } from 'react';
import { isEmpty } from "lodash";
import { TextArea } from '../../../../commonModules/interface/form-input-inline';
import CommercialHelp from './CommercialHelp';
import AddAlert from './AddAlert';
import CallClient from './CallClient';
import AddComment from './AddComment';
import Dialog from '../../../../commonModules/interface/Dialog';

class ActionForms extends Component {
    state = {  }
    render() {
        let content = (<div></div>)
        let title = ""
        
        if (this.props.alertForm) {
            title='Ajouter une Alerte'
            content = (
                <AddAlert {...this.props} />
            )
        } else if (this.props.callForm) {
            title='Appel du Client'
            content = (
                <CallClient {...this.props} />
            )
        } else if (this.props.commentForm) {
            
            title='Ajouter un Commentaire'
            content = (
                <AddComment {...this.props} />
            )
        } else if (this.props.endContractForm) {
            title='Demander La fin du Contrat'
            content = (
                <TextArea
                    id="comment" 
                    onChange={this.handleChange} 
                    value={this.props.comment} 
                    name="comment" 
                    rows={5}
                    label="Résumer la situation"
                    error={this.props.errors.comment}
                />
            )
        } else if (this.props.requestCommercialHelp){
            title ="Solliciter le Commercial"
            content = (
                <CommercialHelp 
                    {...this.props}
                />
            )    
        }
            
        return (
            <Dialog
                block={true}
                title={title}
                text={content}
                submitAction={this.props.handleSubmit}
                disabledSubmit={this.props.STATE.fetching}
                close={this.props.handleClose}
            />
        );
    }
}

export default ActionForms;